import React, { useEffect, useState } from "react";
import styles from "./BundleCard.module.scss";
import { useDataStore } from "store/DataStoreContext";
import Card from "./Card";
import _ from "lodash";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ScrollMenu } from "react-horizontal-scrolling-menu";
import { LeftArrow, RightArrow } from "./arrow";
import "react-horizontal-scrolling-menu/dist/styles.css";
import usePreventBodyScroll from "./usePreventBodyScroll";
import useWindowSize from "hook/useWindowSize";

const BundleCard = ({ handleClickCard, refetch = () => {} }) => {
  const {
    state: { bundle, bundleRelated },
  } = useDataStore();
  const history = useHistory();

  const [isHome, setIsHome] = useState(false);
  const [bundleItem, setBundleItem] = useState();
  const { disableScroll, enableScroll } = usePreventBodyScroll();
  const { width } = useWindowSize();

  useEffect(() => {
    setIsHome(
      _.includes(["/", "", "/bundle/detail"], history.location.pathname)
    );
  }, []);

  useEffect(() => {
    if (history.location.pathname === "/bundle/detail") {
      setBundleItem(bundleRelated);
    } else {
      setBundleItem(bundle);
    }
  }, [bundle, bundleRelated]);

  function onWheel(apiObj, ev) {
    const isThouchpad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < 3;

    if (isThouchpad) {
      ev.stopPropagation();
      return;
    }

    if (ev.deltaY < 0) {
      apiObj.scrollNext();
    } else if (ev.deltaY > 0) {
      apiObj.scrollPrev();
    }
  }

  return (
    !_.isEmpty(bundleItem) && (
      <div
        className={styles.bundle_card_container}
        onMouseEnter={disableScroll}
        onMouseLeave={enableScroll}
      >
        {isHome ? (
          <ScrollMenu onWheel={onWheel}>
            {_.size(bundleItem.data) > 0 &&
              bundleItem.data.map((bundleItem, i) => (
                <Card
                  bundleItem={bundleItem}
                  key={i}
                  handleClickCard={handleClickCard}
                  refetch={refetch}
                />
              ))}
          </ScrollMenu>
        ) : (
          _.size(bundleItem.data) > 0 &&
          bundleItem.data.map((bundleItem, i) => (
            <Card
              bundleItem={bundleItem}
              key={i}
              handleClickCard={handleClickCard}
              refetch={refetch}
            />
          ))
        )}
      </div>
    )
  );
};

export default BundleCard;
